export default __webpack_public_path__ + "static/media/jobPostPicFr.d764a5f6.svg";